import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { cloneDeep } from 'lodash-es';
import { Observable, Subscription } from 'rxjs';
import { Dictionary, DictionaryType } from '../../../../../domain/dictionary.model';
import { ValidationError } from '../../../../../domain/error.model';
import { Cession, CessionPartyType, InsuredProduct } from '../../../../../domain/product.domain';
import { ErrorAwareComponent, LsnErrorStateMatcher } from '../../../../shared/middleware/error-state-matcher';
import { AsideAction } from '../../../store/aside.action';
import { DictionaryState } from '../../../store/dictionary.state';
import { ErrorsState } from '../../../store/errors.state';
import { OfferAction } from '../../../store/offer.action';
import { OfferState } from '../../../store/offer.state';
import { AddressFormComponent } from '../../address-form/address-form.component';

@Component({
    selector: 'app-cession-aside',
    templateUrl: './cession-aside.component.html',
    styleUrls: ['./cession-aside.component.scss']
})
export class CessionAsideComponent implements OnInit, OnDestroy, ErrorAwareComponent {

    @Select(DictionaryState.getDictionaries) dictionaries$: Observable<{ [key: string]: Dictionary }>;
    dictionaryTypes = DictionaryType;
    insuredProduct: InsuredProduct;

    @ViewChild('addressFormComponent') addressFormComponent: AddressFormComponent;

    subscriptions: Subscription[] = [];
    errors: ValidationError[] = [];
    matchers = {
        type: new LsnErrorStateMatcher(this, 'cession.type'),
        name: new LsnErrorStateMatcher(this, 'cession.name'),
        nip: new LsnErrorStateMatcher(this, 'cession.nip'),
        regon: new LsnErrorStateMatcher(this, 'cession.regon'),
        countryOfOrigin: new LsnErrorStateMatcher(this, 'cession.countryOfOrigin'),

    };
    cessionPartyType = CessionPartyType;

    constructor(private store: Store) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(ErrorsState.getAsideErrors).subscribe(errors => this.errors = errors),
            this.store.select(OfferState.getInsuredProduct)
                .subscribe(insuredProduct => {
                    this.insuredProduct = cloneDeep(insuredProduct);
                    if (this.insuredProduct.configuration.cession == null) {
                        this.insuredProduct.configuration.cession = new Cession();
                    }
                }),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    close() {
        this.store.dispatch(AsideAction.CloseRight());
    }

    updateCountry($event: string) {
        this.addressFormComponent?.onCountryChange($event);
        this.insuredProduct.configuration.cession.countryOfOrigin = {code: $event};
        this.insuredProduct.configuration.cession.address.country = {code: $event};
    }

    save() {
        const id = this.store.selectSnapshot(OfferState.getOffer).id;
        this.store.dispatch(new OfferAction.SaveCession(id, this.insuredProduct.id, this.insuredProduct.configuration.cession));
    }
}
